import { t as tr } from '../i18n.js'
import { useQuery } from '@tanstack/react-query'
import { Link, useParams } from 'react-router'
import { api, type PortfolioDetail } from '../api.js'
import { PortfolioTabs } from './PortfolioTabs.js'
import { usePortfolioSource } from './taskSource.js'
import { GanttView } from './GanttView.js'
import './portfolio.css'

/** Portfolio gantt: the multi-project wrapper around GanttView (crumbs + tabs + the portfolio task source). */
export function PortfolioGanttPage() {
  const { portfolioId = '' } = useParams()
  const src = usePortfolioSource(portfolioId)
  // Already fetched by the source under the same key; the name is not part of TaskSource.
  const detail = useQuery({ queryKey: ['portfolio', portfolioId], queryFn: () => api<PortfolioDetail>(`/portfolios/${portfolioId}`), retry: false })

  if (src.status === 'error') return <p className="bad">{tr("Portfolio not found, or you do not have access.")} <Link to="/portfolios">{tr("Back to portfolios")}</Link></p>
  if (src.status === 'pending') return <p className="muted">{tr("Loading…")}</p>

  return <GanttView source={src} header={<>
    <p className="crumbs"><Link to="/portfolios">{tr("Portfolios")}</Link> / {detail.data?.portfolio.name ?? '…'}</p>
    <PortfolioTabs portfolioId={portfolioId} active="gantt" />
  </>} />
}
